import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material' // making these changes till achar sanhita
import {
	HeroTopLeftMessage,
	HeroMantriStrip,
	HeroWrapper,
	PersonCard,
	PersonDesc,
	PersonPic,
} from './StyledComponents'
import { bannerCmStripData, bannerImgUrls } from './data' 

function Hero() {
	const [currentSlide, setCurrentSlide] = useState(0)

	useEffect(() => {
		let timer = setInterval(() => {
			setCurrentSlide(curr => curr + 1 < bannerImgUrls.length ? curr + 1 : 0)
		}, 4000)

		return () => clearInterval(timer)
	}, [])

	return (
		<HeroWrapper bgimg={bannerImgUrls[currentSlide]}>
			<HeroTopLeftMessage>Urban planning is the art of shaping Civilisation.</HeroTopLeftMessage>
			<HeroMantriStrip>
				<Grid container spacing={2}>
					{bannerCmStripData.map(({ photo, name, designation }) => (
						<PersonCard item key={name} xs={12} md={6} lg={12 / bannerCmStripData.length}>
							<PersonPic>
								<img src={photo} alt={name} />
							</PersonPic>
							<PersonDesc>
								<strong>{name}</strong>
								{designation}
							</PersonDesc>
						</PersonCard>
					))}
				</Grid>
			</HeroMantriStrip>
			
		</HeroWrapper>
	)
}

export default Hero
